"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isInitializingReducer = isInitializingReducer, exports.requestingReducer = requestingReducer, exports.requestedReducer = requestedReducer, exports.timestampsReducer = timestampsReducer, exports.authReducer = authReducer, exports.authErrorReducer = authErrorReducer, exports.profileReducer = profileReducer, exports.errorsReducer = errorsReducer, exports.orderedReducer = exports.dataReducer = exports.listenersReducer = void 0;

var _assign2 = _interopRequireDefault(require("lodash/fp/assign")),
    _setWith2 = _interopRequireDefault(require("lodash/fp/setWith")),
    _isObject2 = _interopRequireDefault(require("lodash/isObject")),
    _get2 = _interopRequireDefault(require("lodash/get")),
    _omit2 = _interopRequireDefault(require("lodash/omit")),
    _pick2 = _interopRequireDefault(require("lodash/pick")),
    _constants = require("./constants"),
    _reducers = require("./utils/reducers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (o) {
    if ("string" == typeof o) return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(o, minLen) : void 0;
  }
}

function _iterableToArray(iter) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  (null == len || len > arr.length) && (len = arr.length);

  for (var i = 0, arr2 = Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

var START = _constants.actionTypes.START,
    SET = _constants.actionTypes.SET,
    SET_PROFILE = _constants.actionTypes.SET_PROFILE,
    MERGE = _constants.actionTypes.MERGE,
    LOGIN = _constants.actionTypes.LOGIN,
    LOGOUT = _constants.actionTypes.LOGOUT,
    LOGIN_ERROR = _constants.actionTypes.LOGIN_ERROR,
    CLEAR_ERRORS = _constants.actionTypes.CLEAR_ERRORS,
    REMOVE = _constants.actionTypes.REMOVE,
    NO_VALUE = _constants.actionTypes.NO_VALUE,
    SET_LISTENER = _constants.actionTypes.SET_LISTENER,
    UNSET_LISTENER = _constants.actionTypes.UNSET_LISTENER,
    AUTHENTICATION_INIT_STARTED = _constants.actionTypes.AUTHENTICATION_INIT_STARTED,
    AUTHENTICATION_INIT_FINISHED = _constants.actionTypes.AUTHENTICATION_INIT_FINISHED,
    AUTH_EMPTY_CHANGE = _constants.actionTypes.AUTH_EMPTY_CHANGE,
    AUTH_LINK_SUCCESS = _constants.actionTypes.AUTH_LINK_SUCCESS,
    UNAUTHORIZED_ERROR = _constants.actionTypes.UNAUTHORIZED_ERROR,
    AUTH_UPDATE_SUCCESS = _constants.actionTypes.AUTH_UPDATE_SUCCESS,
    AUTH_RELOAD_SUCCESS = _constants.actionTypes.AUTH_RELOAD_SUCCESS,
    PROFILE_UPDATE_SUCCESS = _constants.actionTypes.PROFILE_UPDATE_SUCCESS;

function isInitializingReducer() {
  var state = !!(0 < arguments.length && arguments[0] !== void 0) && arguments[0],
      action = 1 < arguments.length ? arguments[1] : void 0;

  switch (action.type) {
    case AUTHENTICATION_INIT_STARTED:
      return !0;

    case AUTHENTICATION_INIT_FINISHED:
      return !1;

    default:
      return state;
  }
}

function requestingReducer() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      _ref = 1 < arguments.length ? arguments[1] : void 0,
      type = _ref.type,
      path = _ref.path;

  return type === START ? _objectSpread({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), !0)) : type === NO_VALUE || type === SET ? _objectSpread({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), !1)) : state;
}

function requestedReducer() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      _ref2 = 1 < arguments.length ? arguments[1] : void 0,
      type = _ref2.type,
      path = _ref2.path;

  return type === START ? _objectSpread({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), !1)) : type === NO_VALUE || type === SET ? _objectSpread({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), !0)) : state;
}

function timestampsReducer() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      _ref3 = 1 < arguments.length ? arguments[1] : void 0,
      type = _ref3.type,
      path = _ref3.path;

  return type === START || type === NO_VALUE || type === SET ? _objectSpread({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), Date.now())) : state;
}

function createDataReducer() {
  var actionKey = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : "data";
  return function () {
    var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
        action = 1 < arguments.length ? arguments[1] : void 0;

    switch (action.type) {
      case SET:
        return (0, _setWith2.default)(Object, (0, _reducers.getDotStrPath)(action.path), action[actionKey], state);

      case MERGE:
        var previousData = (0, _get2.default)(state, (0, _reducers.getDotStrPath)(action.path), {}),
            mergedData = (0, _assign2.default)(previousData, action[actionKey]);
        return (0, _setWith2.default)(Object, (0, _reducers.getDotStrPath)(action.path), mergedData, state);

      case NO_VALUE:
        return (0, _setWith2.default)(Object, (0, _reducers.getDotStrPath)(action.path), null, state);

      case REMOVE:
        return "data" === actionKey ? (0, _reducers.recursiveUnset)((0, _reducers.getDotStrPath)(action.path), state) : state;

      case LOGOUT:
        if (action.preserve) {
          if (Array.isArray(action.preserve)) return (0, _pick2.default)(state, action.preserve);
          if ((0, _isObject2.default)(action.preserve)) return action.preserve[actionKey] ? (0, _reducers.preserveValuesFromState)(state, action.preserve[actionKey], {}) : {};
          throw new Error("Invalid preserve parameter. It must be an Object or an Array");
        }

        return {};

      default:
        return state;
    }
  };
}

function authReducer() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {
    isLoaded: !1,
    isEmpty: !0
  },
      action = 1 < arguments.length ? arguments[1] : void 0;

  switch (action.type) {
    case LOGIN:
    case AUTH_UPDATE_SUCCESS:
      if (!action.auth) return {
        isEmpty: !0,
        isLoaded: !0
      };
      var auth = action.auth.toJSON ? action.auth.toJSON() : action.auth;
      return action.preserve && action.preserve.auth ? (0, _reducers.preserveValuesFromState)(state, action.preserve.auth, _objectSpread({}, auth, {
        isEmpty: !1,
        isLoaded: !0
      })) : _objectSpread({}, auth, {
        isEmpty: !1,
        isLoaded: !0
      });

    case AUTH_LINK_SUCCESS:
    case AUTH_RELOAD_SUCCESS:
      return action.payload ? _objectSpread({}, action.payload.toJSON ? action.payload.toJSON() : action.payload, {
        isEmpty: !1,
        isLoaded: !0
      }) : {
        isEmpty: !0,
        isLoaded: !0
      };

    case LOGIN_ERROR:
    case AUTH_EMPTY_CHANGE:
    case LOGOUT:
      return action.reauthenticate ? (0, _reducers.preserveValuesFromState)(state, !0, {}) : action.preserve && action.preserve.auth ? (0, _reducers.preserveValuesFromState)(state, action.preserve.auth, {
        isLoaded: !0,
        isEmpty: !0
      }) : {
        isLoaded: !0,
        isEmpty: !0
      };

    default:
      return state;
  }
}

function authErrorReducer() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : null,
      action = 1 < arguments.length ? arguments[1] : void 0;

  switch (action.type) {
    case LOGIN:
    case LOGOUT:
      return null;

    case LOGIN_ERROR:
    case UNAUTHORIZED_ERROR:
      return action.authError;

    default:
      return state;
  }
}

function profileReducer() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {
    isLoaded: !1,
    isEmpty: !0
  },
      action = 1 < arguments.length ? arguments[1] : void 0;

  switch (action.type) {
    case SET_PROFILE:
      return action.profile ? _objectSpread({}, action.profile, {
        isEmpty: !1,
        isLoaded: !0
      }) : _objectSpread({}, state, {
        isEmpty: !0,
        isLoaded: !0
      });

    case PROFILE_UPDATE_SUCCESS:
      return Object.assign({}, state, action.payload);

    case LOGIN:
      return action.preserve && action.preserve.profile ? (0, _reducers.preserveValuesFromState)(state, action.preserve.profile, {
        isLoaded: !0,
        isEmpty: !0
      }) : {
        isEmpty: !0,
        isLoaded: !1
      };

    case LOGOUT:
    case AUTH_EMPTY_CHANGE:
      return action.preserve && action.preserve.profile ? (0, _reducers.preserveValuesFromState)(state, action.preserve.profile, {
        isLoaded: !0,
        isEmpty: !0
      }) : {
        isLoaded: !0,
        isEmpty: !0
      };

    default:
      return state;
  }
}

function errorsReducer() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [],
      action = 1 < arguments.length ? arguments[1] : void 0;

  switch (action.type) {
    case LOGIN_ERROR:
    case UNAUTHORIZED_ERROR:
      if (!Array.isArray(state)) throw new Error("Errors state must be an array");
      return [].concat(_toConsumableArray(state), [action.authError]);

    case LOGOUT:
    case CLEAR_ERRORS:
      if (action.preserve && action.preserve.errors) {
        if ("function" != typeof action.preserve.errors) throw new Error("Preserve for the errors state currently only supports functions");
        return state.filter(action.preserve.errors);
      }

      return [];

    default:
      return state;
  }
}

function listenersById() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      _ref4 = 1 < arguments.length ? arguments[1] : void 0,
      type = _ref4.type,
      path = _ref4.path,
      payload = _ref4.payload;

  return type === SET_LISTENER ? _objectSpread({}, state, _defineProperty({}, payload.id, {
    id: payload.id,
    path: path
  })) : type === UNSET_LISTENER ? (0, _omit2.default)(state, [payload.id]) : state;
}

function allListeners() {
  var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [],
      _ref5 = 1 < arguments.length ? arguments[1] : void 0,
      type = _ref5.type,
      path = _ref5.path,
      payload = _ref5.payload;

  return type === SET_LISTENER ? [].concat(_toConsumableArray(state), [payload.id]) : type === UNSET_LISTENER ? state.filter(function (lId) {
    return lId !== payload.id;
  }) : state;
}

var listenersReducer = (0, _reducers.combineReducers)({
  byId: listenersById,
  allIds: allListeners
});
exports.listenersReducer = listenersReducer;
var dataReducer = createDataReducer();
exports.dataReducer = dataReducer;
var orderedReducer = createDataReducer("ordered");
exports.orderedReducer = orderedReducer;